var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card-header pl-0" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("div", { staticClass: "dropdown mr-3 d-none" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "inspectorDropdown" }
              },
              [
                _c("li", { staticClass: "d-none" }, [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "default"
                        }
                      }
                    },
                    [_vm._v("Default")]
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _c(
                    "span",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          _vm.activeComponent = "main"
                        }
                      }
                    },
                    [_vm._v("Main")]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("span", { staticClass: "text-primary ml-3" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$parent.activeComponentTitle) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          !_vm.showModal && (_vm.selectedCharecterName || _vm.charData)
            ? _c(
                "div",
                { staticClass: "btn-menu-wrapper navbar navbar-expand-lg" },
                [
                  _c("ul", { staticClass: "navbar-nav" }, [
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "nav-link",
                          class: { active: _vm.activeComponent == "main" },
                          on: {
                            click: function($event) {
                              _vm.activeComponent = "main"
                            }
                          }
                        },
                        [_vm._v("\n              Main\n            ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "nav-link",
                          class: { active: _vm.activeComponent == "tts" },
                          on: {
                            click: function($event) {
                              _vm.activeComponent = "tts"
                            }
                          }
                        },
                        [_vm._v("\n              Voice\n            ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "nav-link",
                          class: {
                            active: _vm.activeComponent == "animations"
                          },
                          on: {
                            click: function($event) {
                              _vm.activeComponent = "animations"
                            }
                          }
                        },
                        [_vm._v("\n              Animation\n            ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "nav-link",
                          class: { active: _vm.activeComponent == "movement" },
                          on: {
                            click: function($event) {
                              _vm.activeComponent = "movement"
                            }
                          }
                        },
                        [_vm._v("\n              Movement\n            ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "nav-link",
                          class: { active: _vm.activeComponent == "effects" },
                          on: {
                            click: function($event) {
                              _vm.activeComponent = "effects"
                            }
                          }
                        },
                        [_vm._v("\n              Effect\n            ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "nav-link",
                          class: { active: _vm.activeComponent == "light" },
                          on: {
                            click: function($event) {
                              _vm.activeComponent = "light"
                            }
                          }
                        },
                        [_vm._v("\n              Light\n            ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "span",
                        {
                          staticClass: "nav-link",
                          class: { active: _vm.activeComponent == "sound" },
                          on: {
                            click: function($event) {
                              _vm.activeComponent = "sound"
                            }
                          }
                        },
                        [_vm._v("\n              Sound\n            ")]
                      )
                    ])
                  ])
                ]
              )
            : _vm._e()
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c(
        "div",
        { staticClass: "inspector-wrapper" },
        [
          [
            _c("div", { staticClass: "row" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row", staticStyle: { "min-height": "300px" } },
              [
                _c(
                  "div",
                  { staticClass: "col-9" },
                  [
                    _vm.activeComponent == "main"
                      ? _c("maininspector", {
                          attrs: {
                            charData: _vm.charData,
                            currentIndex: _vm.currentIndex
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeComponent == "animations"
                      ? _c("animations", {
                          on: { selectedAnimation: _vm.changeSelectedAnimation }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeComponent == "effects" ? _c("effects") : _vm._e(),
                    _vm._v(" "),
                    _vm.activeComponent == "light" ? _c("light") : _vm._e(),
                    _vm._v(" "),
                    _vm.activeComponent == "movement"
                      ? _c("movement")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeComponent == "sound" ? _c("sound") : _vm._e(),
                    _vm._v(" "),
                    _vm.activeComponent == "tts" ? _c("tts") : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.selectedCharecter
                  ? _c("div", { staticClass: "col-3 position-relative" }, [
                      _vm.selectedCharecter
                        ? _c("h4", [_vm._v(_vm._s(_vm.selectedCharecter.name))])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "selected-char-imgwrap" }, [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src:
                              _vm.selectedCharecter.objectDbHash &&
                              _vm.fbxModels[_vm.selectedCharecter.objectDbHash]
                                .image.imageURL
                          }
                        })
                      ])
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm._m(2)
          ],
          _vm._v(" "),
          _vm.showModal
            ? [
                _c(
                  "div",
                  {
                    staticClass: "modal",
                    attrs: {
                      id: "character-modal",
                      tabindex: "-1",
                      role: "dialog",
                      "data-backdrop": "static",
                      "data-keyboard": "false"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "modal-dialog modal-lg",
                        attrs: { role: "document" }
                      },
                      [
                        _c("div", { staticClass: "modal-content" }, [
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                                "aria-label": "Close"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.closeModal()
                                }
                              }
                            },
                            [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm._m(3),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "modal-body" },
                            [
                              _c("character", {
                                on: {
                                  triggerSelectedModel: _vm.changeSelectedModel
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-card-header dropdown-toggle",
        attrs: {
          type: "button",
          id: "inspectorDropdown",
          "data-toggle": "dropdown",
          "aria-expanded": "false"
        }
      },
      [
        _c("img", {
          staticClass: "heading-icon mr-2",
          attrs: { src: require("@/assets/addplus_icon.svg") }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "pr-2 text-capitalize" }, [_vm._v(" Add")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "ml-3" }, [
      _c("img", {
        staticClass: "heading-icon mr-2",
        attrs: { src: require("@/assets/device_hub_icon.svg") }
      }),
      _vm._v("\n        Inspector")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mt-4 d-none" }, [
      _c("div", { staticClass: "col-12 text-center" }, [
        _c("button", { staticClass: "btn btn-outline-primary mr-3" }, [
          _vm._v("Save")
        ]),
        _vm._v(" "),
        _c("button", { staticClass: "btn btn-outline-secondary" }, [
          _vm._v("Cancel")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h4", { staticClass: "text-center font-size-20" }, [
        _vm._v("\n                  Character Model\n                ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fb3c3fb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fb3c3fb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-wrap/characterInspector.vue
// module id = null
// module chunks = 